import FieldLayout from './field-layout'
import { markRaw } from 'vue'

export default {
  data() {
    return {
      fieldLayoutComponent: markRaw(FieldLayout)
    }
  },

  mounted() {
    this.$refs.field.$refs.input.focus()
  },

  methods: {
    focus() {
      this.$refs.field.$refs.input.focus()
    },

    scrollIntoView() {
      this.$refs.field.scrollIntoView()
    }
  }
}
